import { TypedDocumentNode, gql } from '@apollo/client';

import { footballRivalsInviteAcceptCodeInput } from '@sorare/core/src/__generated__/globalTypes';
import useMutation from '@sorare/core/src/hooks/graphql/useMutation';

import {
  FootballRivalsInviteAcceptCodeMutation,
  FootballRivalsInviteAcceptCodeMutationVariables,
} from './__generated__/useFootballRivalsInviteAcceptCode.graphql';

const FOOTBALL_RIVALS_INVITE_ACCEPT_CODE_MUTATION = gql`
  mutation FootballRivalsInviteAcceptCodeMutation(
    $input: footballRivalsInviteAcceptCodeInput!
  ) {
    footballRivalsInviteAcceptCode(input: $input) {
      game {
        slug
        myLineup {
          id
        }
        game {
          id
          status: statusTyped
          date
        }
      }
      errors {
        code
        message
      }
    }
  }
` as TypedDocumentNode<
  FootballRivalsInviteAcceptCodeMutation,
  FootballRivalsInviteAcceptCodeMutationVariables
>;

const useFootballRivalsInviteAcceptCode = () => {
  const [mutate, { loading }] = useMutation(
    FOOTBALL_RIVALS_INVITE_ACCEPT_CODE_MUTATION,
    {
      showErrorsWithSnackNotification: true,
    }
  );

  return [
    async (input: footballRivalsInviteAcceptCodeInput) =>
      mutate({ variables: { input } }),
    { loading },
  ] as const;
};

export default useFootballRivalsInviteAcceptCode;
